import React from 'react';
import { useNavigate } from 'react-router-dom';
import CounterOrder from './CounterOrder';

const FullscreenCounterOrders = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-amber-50/50 via-white to-orange-50/40">
      <header className="sticky top-0 z-20 bg-white/95 backdrop-blur-sm border-b-2 border-orange-400 shadow-sm">
        <div className="w-full px-2 sm:px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-2 sm:gap-3 min-w-0">
              <button
                onClick={() => navigate(-1)}
                className="flex-shrink-0 p-1.5 rounded-lg bg-stone-100 text-stone-700 hover:bg-stone-200 active:scale-95 transition-all"
                aria-label="Back"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <div>
                <h1 className="text-lg sm:text-xl font-bold text-stone-800 truncate">Counter Orders</h1>
                <p className="text-xs text-stone-500 mt-0.5">Fullscreen view</p>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="w-full px-2 sm:px-4 py-3 sm:py-5">
        <CounterOrder isFullscreen={true} />
      </main>
    </div>
  );
};

export default FullscreenCounterOrders;
